<template>
  <!--
    https://github.com/sagalbot/vue-select - Docs

  -->
  <vue-select
    :class="{
      'placeholder-not-showing': !showPlaceholder,
      'custom-select': true,
      'vue-select': true,
      'vue-select__disabled': disabled,
      'vue-select__medium': isMedium
    }"
    :options="options"
    :placeholder="placeholder"
    v-model="value"
    :multiple="false"
    :clear-on-select="false"
    :hide-selected="true"
    :label="label"
    track-by="name"
    :debounce="250"
    :disabled="disabled"
    :on-search="searchOptions"
    @search:focus="checkPosition"
    @search:blur="clearOptionsIfEmpty"
    :getOptionLabel="getOptionLabel"
  ></vue-select>
</template>

<script>
import VueSelect from 'vue-select'

const SIZE = {
  LARGE: 1,
  MEDIUM: 2,
  SMALL: 3
}

export default {
  components: {
    VueSelect
  },
  props: {
    placeholder: {
      type: String,
      default: 'Search'
    },
    initialValue: {
      default: null
    },
    options: {
      type: Array,
      default: []
    },
    searchOptions: {
      type: Function,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: 'Name'
    },
    size: {
      type: Number,
      default: SIZE.LARGE
    },
    getOptionLabel: {
      type: Function,
      default: undefined
    }
  },
  data () {
    return {
      value: this.initialValue && (typeof this.initialValue !== 'object' || Object.keys(this.initialValue).length > 0) ? this.initialValue : null
    }
  },
  computed: {
    showPlaceholder () {
      return !this.value
    },
    isMedium () {
      return this.size === SIZE.MEDIUM
    }
  },
  methods: {
    preventTheDefault (e) {
      // Prevent enter key press to select an advertiser from submitting the form
      // This is a fix for the vue-select plugin
      if (e.keyCode === 13) {
        e.preventDefault()
      }
    },
    clear () {
      this.value = null
    },
    clearOptionsIfEmpty () {
      if (!this.value) {
        this.$emit('clearOptions')
      }
    },
    checkPosition () {
      setTimeout(() => {
        const windowBottom = window.innerHeight
        const dropdownMenu = this.$el.querySelector('.dropdown-menu')
        if (dropdownMenu) {
          const dropdownMenuBounds = dropdownMenu.getBoundingClientRect()
          const dropdownMenuBottom = dropdownMenuBounds.bottom
          const dropdownMenuCalculatedBottom = dropdownMenuBounds.y + dropdownMenuBounds.height
          const dropdownMenuCalculatedHeight = windowBottom - dropdownMenuBounds.y
          if (dropdownMenuCalculatedBottom > windowBottom) {
            dropdownMenu.style.height = `${dropdownMenuCalculatedHeight - 5}px`
          }
        }
      }, 0)
    }
  },
  mounted () {
    this.searchInput = this.$el.querySelector('input[type=search]')
    this.searchInput.addEventListener('keypress', this.preventTheDefault)
  },
  watch: {
    value: function (val) {
      this.$emit('update', val)
    },
    initialValue: function (val) {
      this.value = val
    },
    options: function () {
      this.checkPosition()
    }
  }
}

</script>

<style lang="scss">
.v-select {
  input {
    width: 100% !important;
  }

  &__medium {
    width: 300px;
  }

  &__disabled {
    input {
      cursor: not-allowed;
      pointer-events: none;
    }
    ul {
      cursor: not-allowed;
      pointer-events: none;
      li {
        cursor: not-allowed;
        pointer-events: none;
        a {
          cursor: not-allowed;
          pointer-events: none;
        }
      }
    }
  }

  .selected-tag {
    z-index: 1;
  }

  &.placeholder-not-showing {
    input {
      position: absolute;
      left: 0;
    }

    &.open input {
      position: relative;
    }
  }

  .dropdown-toggle {
    border: 1px solid rgba(60,60,60,.26) !important;
    border-radius: 0 !important;
  }

  .dropdown-menu {
    position: fixed !important;
    top: unset !important;
    left: unset !important;
    width: fit-content !important;
    // width: inherit !important;
    // max-width: inherit !important;
    overflow-y: auto !important;
    border-top: 1px solid rgba(60,60,60,.26) !important;
    transform: translateY(-1px);
  }

  // Replacing the message
  .no-options {
    visibility: hidden !important;
    position: relative !important;
    min-height: 66px;
  }

  .no-options::after {
    visibility: visible;
  	position: absolute;
  	top: 0;
  	left: 0;
  	content: "No results. Search terms must be at least two characters.";
  }

}
</style>



// WEBPACK FOOTER //
// StyledSelect.vue?5cf2ddd1